module.exports = __webpack_public_path__ + "img/D202005_1.04e94a46.jpg";